import { IntroIFrame, IntroWrapper } from './__intro-elements';
import { HelpMode, StartTour, Tutorials } from './_intro-app';
import { IntroKeys } from './intro-keys';

const QuickStartSteps = () => (
  <IntroWrapper size="medium">
    <h3>Let's get started!</h3>
    <p>This Quick Start guide will help you navigate through the app. Here's the basic workflow outline:</p>
    <ol>
      <li>Create a Project</li>
      <li>Add a Music File</li>
      <li>Add Video and/or Photo files</li>
      <li>Create a Story</li>
      <li>Tag Highlights</li>
      <li>Storyboarding</li>
      <li>Render</li>
      <li>Download or share your Final Cut</li>
    </ol>
    <p>
      Click <b>Next</b> if you are ready to take a tour.{' '}
    </p>
  </IntroWrapper>
);

const NavigationPanel = () => (
  <IntroWrapper>
    <p>
      The <b>Navigation Panel</b> is on the left.
    </p>
    <p>Start with Projects, and as you complete the required steps, the next page will become available.</p>
  </IntroWrapper>
);

const Projects = () => (
  <IntroWrapper>
    <p>
      <b>Projects</b> page: Add your Project, Files, and Story.
    </p>
  </IntroWrapper>
);

const ProjectsIntro = () => (
  <IntroWrapper size="medium">
    <h2>Project, Files, and Story</h2>
    <ol>
      <li>Add a Project</li>
      <li>
        Add a Music File — <i>Music is required, Pulse cuts to the beat!</i>
      </li>
      <li>Add Video and/or Photo files</li>
      <li>
        Add a Story — <i>You may have different stories to tell about your project</i>
      </li>
    </ol>
    <IntroIFrame src="https://www.youtube.com/embed/gz3Dycqz3xE" />
  </IntroWrapper>
);

const CreateProject = () => (
  <IntroWrapper>
    <p>
      Add a project by clicking the <b>Add Project</b> button.
    </p>
  </IntroWrapper>
);

const AddFiles = () => (
  <IntroWrapper size="medium">
    <p>
      After your project is created you'll need to <b>Add Files</b>
    </p>
    <ul>
      <li>
        Add <b>at least one music file</b>
      </li>
      <li>
        Add <b>at least one video or photo file</b>
      </li>
      <li>The larger the source file the longer it will take to upload and process</li>
    </ul>
  </IntroWrapper>
);

const CreateStory = () => (
  <IntroWrapper>
    <p>
      Add a <b>Story</b>
    </p>
    <p>Projects can have multiple stories: you may have different stories (or versions) to tell about your project</p>
  </IntroWrapper>
);

const Highlights1 = () => (
  <IntroWrapper size="medium">
    <h3>Highlights</h3>
    <p>
      After the story requirements have been completed you can navigate to the <b>Highlights</b> page.
    </p>
    <h4>Requirements</h4>
    <ul>
      <li>At least one music file is Available</li>
      <li>At least one video or photo file is Available</li>
      <li>At least one story has been created</li>
    </ul>
    <p>
      The <b>Highlights</b> button will remain disabled until all three requirements have been completed.
    </p>
  </IntroWrapper>
);

const Highlights2 = () => (
  <IntroWrapper>
    <p>
      If all story requirements are complete, navigate to <b>Highlights</b> by clicking here.
    </p>
  </IntroWrapper>
);

export const STEPS_PROJECTS = [
  { intro: <QuickStartSteps /> },
  { element: `[data-intro="${IntroKeys.navHelpMode}"]`, intro: <HelpMode /> },
  { element: `[data-intro="${IntroKeys.navStartTour}"]`, intro: <StartTour /> },
  { element: `[data-intro="${IntroKeys.navTutorials}"]`, intro: <Tutorials /> },
  { element: `[data-intro="${IntroKeys.navigator}"]`, intro: <NavigationPanel /> },
  { element: `[data-intro="${IntroKeys.navProjects}"]`, intro: <Projects /> },
  { intro: <ProjectsIntro /> },
  { element: `[data-intro="${IntroKeys.createProject}"]`, intro: <CreateProject /> },
  { element: `[data-intro="${IntroKeys.addFiles}"]`, intro: <AddFiles /> },
  { element: `[data-intro="${IntroKeys.createStory}"]`, intro: <CreateStory /> },
  { element: `[data-intro="${IntroKeys.navSr}"]`, intro: <Highlights1 /> },
  { element: `[data-intro="${IntroKeys.navSr}"]`, intro: <Highlights2 /> },
];
